module.exports = __webpack_public_path__ + "static/media/billetera.1f13d9d0.svg";